import { useParamsSearch } from '@anytag/shared-hooks';
import { PostInsightDetailsSearchFilterSchemaType } from '../schema-types';

export const usePostInsightFilter = () => useParamsSearch<PostInsightDetailsSearchFilterSchemaType>();
